export default __webpack_public_path__ + "static/media/notes.33d450c7.svg";